import React, { useState } from 'react';
import '../components/styles/faq.css';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqItems = [
    {
      question: "What types of makeup services do you offer?",
      answer: "I offer a range of makeup services including bridal makeup, glam makeup, soft natural looks, special event makeup, and custom makeup lessons."
    },
    {
      question: "Do you offer makeup trials for brides?",
      answer: "Yes! I highly recommend a trial session for brides, allowing us to perfect the look for your big day and ensure you feel comfortable and confident."
    },
    {
      question: "What makeup products do you use?",
      answer: "I use high-quality, professional-grade makeup products, including cruelty-free and skin-friendly options, to achieve long-lasting, flawless results."
    },
    {
      question: "How long does a makeup application take?",
      answer: "The duration depends on the complexity of the look. For a standard makeup application, it usually takes about 45 minutes to 1 hour, while more intricate styles, like bridal makeup, may take up to 1.5-2 hours."
    },
    {
      question: "Do you offer group or bridal party makeup services?",
      answer: "Yes, I can accommodate group bookings and bridal party makeup, ensuring everyone looks and feels their best for your special event."
    },
    {
      question: "Can you do makeup for all skin types and tones?",
      answer: "Absolutely! I specialize in creating looks for all skin tones and types, ensuring that each makeup application is tailored to highlight your unique features."
    },
    {
      question: "How far in advance should I book my appointment?",
      answer: "I recommend booking at least 4-6 weeks in advance, especially for weddings and special events, to ensure availability."
    },
    {
      question: "Can I book a makeup lesson?",
      answer: "Yes, I offer one-on-one makeup lessons where we can go over techniques, product recommendations, and create a personalized routine to suit your style."
    },
    {
      question: "Do you travel to locations for makeup services?",
      answer: "Yes, I offer on-location makeup services for events, weddings, and photoshoots. Travel fees may apply depending on the location."
    },
    {
      question: "What should I do before my makeup appointment?",
      answer: "Please ensure your face is clean, moisturized, and free of heavy skincare products or makeup. It's also helpful to bring any inspiration photos or ideas for your desired look."
    }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <div className="faq-header">
        <h1>Frequently Asked Questions</h1>
        <p className="faq-subtitle">Find answers to common questions about our makeup services</p>
      </div>

      <div className="faq-list">
        {faqItems.map((item, index) => (
          <div 
            key={index} 
            className={`faq-item ${activeIndex === index ? 'active' : ''}`}
          >
            <button 
              className="faq-question"
              onClick={() => toggleAccordion(index)}
            >
              {item.question}
              <span className="faq-icon">
                {activeIndex === index ? '−' : '+'}
              </span>
            </button>
            <div className={`faq-answer ${activeIndex === index ? 'show' : ''}`}>
              {item.answer}
            </div>
          </div>
        ))}
      </div>

      <div className="faq-footer">
        <p>Still have questions?</p>
        <button className="contact-button"
        href='/contact'>Contact Us</button>
      </div>
    </div>
  );
};

export default FAQ;